import script from "./DeleteAccountPreCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccountPreCheck.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAccountPreCheck.vue?vue&type=style&index=0&id=50a5d506&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a5d506"]])

export default __exports__